
import moment from 'moment'
import XLSX from 'xlsx'
import HSOStockOpname from './hso-stock-opname'

var methods={
  initialiseFilter(filter){
    if(!(typeof filter === 'object' && filter !== null)){
      this.filterUrl = '';
      return;
    }
    var keys = Object.keys(filter);
    let stringUrl = '';
    var queryParams = filter;

    for(var i = 0 ; i < keys.length; i++){
      if(!queryParams[keys[i]])
        continue;

      if(queryParams[keys[i]] == '' || queryParams[keys[i]].length == 0)
        continue 

      if((keys[i] == 'user_type') && queryParams[keys[i]] == 'All')
        continue;
      
      // if(keys[i] == 'start_hour' || keys[i] == 'end_hour')
      //   queryParams[keys[i]] += ":00";
      
      if([keys[i]] == 'start' || keys[i] == 'end') queryParams[keys[i]] = moment(queryParams[keys[i]]).format('Y-MM-DD')
      

      stringUrl += `&${keys[i]}=${queryParams[keys[i]]}`;
      
    }
    return stringUrl;
  },
  errorPrint(errorMessage){//PRINTS ERROR IN RED COLOR
    var error = "%c" + errorMessage;
    console.log(error, 'color:#ff0000')
  },
  printTest(){//PRINTS THE WORD 'TEST'
    console.log("test");
  },
  printDate(date){
    if(date != null) return moment(date).format("DD MMM YY HH:mm")
    else return '-';
  },
  isMobile(){
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
      return true;
    } else {
      return false;
    }
  },
  numberWithCommas(x) {
    return parseInt(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  exportExcel(data, title) {
    let wb = XLSX.utils.book_new()
    let exportFileName = title ? `${title}.xlsx` : 'Exported Data.xlsx'
    var ws = XLSX.utils.json_to_sheet(data, {raw:true});
    XLSX.utils.book_append_sheet(wb, ws, 'Data')
    XLSX.writeFile(wb, exportFileName)
  },
  randomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
  },
  toCapitalizedWords(name){
    var words = name.match(/[A-Za-z][a-z]*/g) || [];
    return words.map(this.capitalize).join(" ");
  },
  capitalize(s){
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  },
  randomDate(start, end) {//example "2020-02-01 02:30:50" OR just "2020-02-01"
    var startDate = new Date(start)
    var endDate = new Date(end)

    var date = new Date(+startDate + Math.random() * (endDate - startDate));
    return date.toISOString().slice(0, 19).replace(/T/g, " ");
  },
  isRTL () {
    return document.documentElement.getAttribute('dir') === 'rtl' || document.body.getAttribute('dir') === 'rtl'
  },
  featureUnavailable(){
    this.$store.dispatch('triggerAlert', [false, ['Fitur Belum Tersedia']])
  },
  isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
},


  

  //Load Filter Options
  async loadFilterOptions (module) {
    var filter = [
      {varName:'products', url:'product'},
      {varName:'provinsi', url:'provinsi'},
      // {varName:'kabupaten', url:'kabupaten'},
      // {varName:'kecamatan', url:'kecamatan'},
      // {varName:'kelurahan', url:'kelurahan'},
      // {varName:'tps', url:'tps'},
    ]

    let exceptions = [] //without sort by name and sort order descending (varName only)

    if(module != null){
      let index = filter.map(x=>x.varName).indexOf(module)

      //if module is found, change filter to the only module selected
      if(index != -1) filter = filter.splice(index, 1);
    } else {
      //If no module is specified, generate month and year
      this.generateMonthYear();
    }

    let promises = [];

    for (var i = 0 ; i < filter.length; i++) {
      var url = `/feed/${filter[i].url}?pagination=false`;

      if (exceptions.indexOf(filter.map(x=>x.varName)[i]) === -1) //Exception
        url+=`&by=name&order=ASC`

      let individualName = filter[i].varName

      promises.push(this.$http.get(url)
      .then((resp) => {
        var data = resp.data.data;

        console.log(`set${this.capitalize(individualName)}`)
        this.$store.dispatch(`set${this.capitalize(individualName)}`, data)
      })
      .catch(err => console.log(err)));
    }//FOR LOOP ENDS

    if (module == null) {
      Promise.all(promises).then(()=>{
        console.log('%cLogin.vue line:109 hello world 2', 'color: #007acc;');
      })
      .catch((err)=>{console.log(err)});
    }
  },
  generateMonthYear () {
    //Generate Month Options
    let monthName = ['January' , 'February' , 'March' , 'April', 'May', 'June' , 'July', 'August', 'September', 'October' , 'November', 'December']
    this.$store.dispatch('setMonth', monthName.map((mon, i) => ({value:i+1, name:mon})))

    //Generate Year Options
    var year = []
    for (var j = new Date().getFullYear(); j >= 2000; j--) year.push(j.toString())
    this.$store.dispatch('setYear', year)
  },
  async getModules () {
    let result = null
    await this.$http.get('/api/v1/masterData/sidebar')
    .then((resp)=>{
      result = resp.data.data.map((x)=>{
        let firstChild = {path:x.link, title:x.name, icon:x.icon, code:x.code}

        if(x.children.length > 0){
          firstChild.children = x.children.map((y)=>{
            let secondChild = {path:y.link, title:y.name, code:y.code}
            if (y.children.length > 0) secondChild.children=y.children.map((z)=>{return{path:z.link, title:z.name, code:z.code}})
            return secondChild
          })
        }

        return firstChild
      })

      this.$store.state.modules = result
    })
    .catch((err)=>{console.log(err)})
    return result;
  },
}


console.log(Object.assign({} , methods , HSOStockOpname))
export default Object.assign({} , methods , HSOStockOpname);